module.exports = __webpack_public_path__ + "img/ic-arrow-e.5473d4eb.svg";